<template>
    <History :items="this.$store.getters['proposal/proposalHistory']" :title="'Activity History & Comments'" />
</template>

<script>
import History from '$Components/History';

export default {
    name: 'ProposalHistory',

    components: {
        History,
    },

    props: {
        applicationId: { type: Number, default: null },
        proposalId: { type: Number, default: null }
    },

    mounted() {
        const ids = { applicationId: this.applicationId, proposalId: this.proposalId };
        this.$store.dispatch('proposal/fetchProposalHistory', ids);
    },
};
</script>
